import { PublicClientApplication } from "@azure/msal-browser";
import { MS_CONFIG } from "config/config";

const msalInstance = new PublicClientApplication(MS_CONFIG);

// using this global variable, for triggering the exchange token flow
export const ssoMsTriggerTokenExchange = { token: "" };

// Initialize MSAL instance once at startup
export const initializeMsal = async () => {
  await msalInstance.initialize();
  return msalInstance;
};

export const getSsoMsTriggerTokenExchange = (): string => {
  return ssoMsTriggerTokenExchange.token;
};

export const setSsoMsTriggerTokenExchange = (value: string) => {
  ssoMsTriggerTokenExchange.token = value;
};

export const handleMsResponse = (response: any) => {
  // handle redirect response
  msalInstance.clearCache();
  // msalInstance.logoutRedirect();
  if (response && response.accessToken) {
    ssoMsTriggerTokenExchange.token = response.accessToken;
  } else {
    ssoMsTriggerTokenExchange.token = "";
  }
};

export { msalInstance };
